import axios from "axios";
import { STATUSES } from "./apiStatus";
import { base_url } from "../utils";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

export const submitPassword = createAsyncThunk(
  "password/password",
  async (password, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${base_url}/EsignServices/loginUser`, password);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const passwordSlice = createSlice({
  name: "password",
  initialState: {
    data: {},
    status: STATUSES.IDLE,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(submitPassword.pending, (state, action) => {
        state.status = STATUSES.LOADING;
      })
      .addCase(submitPassword.fulfilled, (state, action) => {
        state.data = action.payload;
        // state.status = STATUSES.IDLE;
      })
      .addCase(submitPassword.rejected, (state, action) => {
        state.status = STATUSES.ERROR;
        state.error = action.payload;
      });
  },
});

export default passwordSlice.reducer;
